module.exports = __webpack_public_path__ + "img/94024.eba59748.svg";